var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#0061FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00563 3.375L14.625 9.07875L14.4141 9.27C14.3182 9.3606 14.2183 9.44693 14.1148 9.52875C13.9314 9.67556 13.7379 9.82181 13.5433 9.95175C12.7563 10.4846 11.881 10.8735 10.9581 11.1004C10.3191 11.2579 9.66319 11.3366 9.00563 11.3366C8.17313 11.3366 7.34625 11.2129 6.55312 10.9597C5.74173 10.7049 4.97599 10.3227 4.28456 9.82744C4.04549 9.65209 3.81426 9.46629 3.59156 9.27056L3.375 9.07875L3.99094 8.45325L9.00563 3.375ZM13.9207 9.26437C14.004 9.19687 14.0867 9.12937 14.1593 9.05625L9 3.83062L3.84131 9.05625L3.9465 9.14625C4.11862 9.28688 4.29019 9.4275 4.46794 9.55125C5.78987 10.5011 7.37784 11.0096 9.00563 11.0042C9.63945 11.0035 10.2709 10.926 10.8861 10.7736C11.7728 10.5545 12.614 10.1809 13.3712 9.66994C13.5613 9.54506 13.7447 9.4095 13.9207 9.26494V9.26437ZM5.46638 8.99437C6.55263 8.5104 7.72758 8.25737 8.91675 8.25131C10.3151 8.25131 11.6904 8.62256 12.8942 9.33244L12.9724 9.37744L12.8942 9.42806C12.0988 9.93867 11.2112 10.2887 10.2814 10.4586L10.2594 10.4642L10.2426 10.4529C8.82598 9.57035 7.19054 9.1021 5.5215 9.10125H5.21663L5.46638 8.99437ZM10.3258 10.1205C11.0301 9.9855 11.7017 9.74363 12.3227 9.39431C11.2662 8.85577 10.0969 8.57584 8.91113 8.57756C8.19675 8.57756 7.48631 8.67319 6.79781 8.86444C8.04656 9.03319 9.24694 9.46069 10.3258 10.1205ZM12.1843 11.2298C11.9337 11.5706 11.6672 11.8995 11.3856 12.2153L9.00563 14.625L7.3305 12.9302L7.68488 12.9077C8.86987 12.8343 10.0221 12.4894 11.0526 11.8997C11.3631 11.7478 12.1843 11.2298 12.1843 11.2298ZM8.05163 13.2008L9.00563 14.1688L10.692 12.4571C9.86113 12.8549 8.96794 13.1064 8.05163 13.2008Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAst);
export default __webpack_public_path__ + "static/media/ast.a0c66cd8010790e80f8560b18fc539f8.svg";
export { ForwardRef as ReactComponent };